@if (!readOnly && (isAppFormReady$ | async) !== true) {
  <div class="loading-screen-wrapper">
    <mat-spinner aria-label="Loading"></mat-spinner>
  </div>
}

<mat-stepper linear="true" #stepper [class.hideStepper]="hideStepper || readOnly">
  <mat-step [completed]="isContactInfoReady" [select]="activeMenuOrder === 1" label="Contact Info"></mat-step>
  <mat-step [completed]="isProductInfoReady" [select]="activeMenuOrder === 2" label="Coverage Type"></mat-step>
  <mat-step [completed]="isBusinessTypeReady" [select]="activeMenuOrder === 3" label="Business Types"></mat-step>
</mat-stepper>
@if (activeMenuOrder > 0) {
  @if ((isContactInfoReady && (isAppFormReady$ | async)) || readOnly) {
    <appform-contact-info-questions
      class="field"
      [readOnly]="readOnly"
      [formData]="formData"
      (answerUpdate)="updateQuestionSet($event)"
      >
    </appform-contact-info-questions>
  }
  @if ((isProductInfoReady && (isAppFormReady$ | async)) || readOnly) {
    <appform-product-info-questions
      class="field coverageTypes"
      [readOnly]="readOnly"
      [formData]="formData"
      (answerUpdate)="updateQuestionSet($event)"
      >
    </appform-product-info-questions>
  }
  @if (isBusinessTypeReady) {
    <appform-business-type-input
      class="field"
      [isAppSyncedWithBP$]="isAppSyncedWithBP$"
      [readOnly]="readOnly"
      [formData]="formData"
      (answerUpdate)="updateQuestionSet($event)"
      (webComponentLoad)="onWebComponentLoad($event)"
      >
    </appform-business-type-input>
  }
  @if ((isAppFormReady$ | async) && !readOnly) {
    <appform-question-set-save-button></appform-question-set-save-button>
  }
}
